import { RootState } from '../rootReducer';

export const selectGeolocation = (state: RootState) => state.geolocation.geolocation.geolocation;
